import { render } from "./Catalog.vue?vue&type=template&id=24a30d70&ts=true"
import script from "./Catalog.vue?vue&type=script&lang=ts"
export * from "./Catalog.vue?vue&type=script&lang=ts"

import "./Catalog.vue?vue&type=style&index=0&id=24a30d70&lang=scss"

import exportComponent from "/home/deploy/wesgroup-production/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__